/* ============================================================
   Nerosà London — Bundle Builder JS  (Option 2: Bundle Variants)
   File: assets/nerosa-bundle-builder.js

   When a customer completes a bundle, we add a single
   "Nerosà Duo/Trio Bundle" product variant to the cart — already
   priced correctly — with line item properties recording which
   scents are included. No discount codes, no cart attributes,
   no iframe tricks. Works for any quantity of bundles.
   ============================================================ */

(function () {
  'use strict';

  /* ── Bundle variant IDs (Shopify Admin → Products → variant URL) ── */
  var BUNDLE_VARIANTS = {
    '2-2': 57120141869387,   /* Duo  — Standard + Standard   £59.99 */
    '2-1': 57120141902155,   /* Duo  — Standard + Mid        £69.99 */
    '2-0': 57120141934923,   /* Duo  — Mid + Mid             £84.99 */
    '3-3': 57120142229835,   /* Trio — Std + Std + Std       £79.99 */
    '3-2': 57120142262603,   /* Trio — Std + Std + Mid       £89.99 */
    '3-1': 57120142295371,   /* Trio — Std + Mid + Mid       £99.99 */
    '3-0': 57120142524747    /* Trio — Mid + Mid + Mid      £114.99 */
  };

  /* ── Display prices (pence) — for showing RRP & saving in UI ─── */
  var BUNDLE_PRICES = {
    2: { 2: 5999, 1: 6999, 0: 8499 },
    3: { 3: 7999, 2: 8999, 1: 9999, 0: 11499 }
  };

  var PER_PAGE = 12;

  /* ── State ──────────────────────────────────────────────────── */
  var _size     = 2;
  var _selected = [];
  var _filter   = 'all';
  var _page     = 1;
  var _query    = '';

  /* ── DOM refs ───────────────────────────────────────────────── */
  var $slots, $grid, $pagination, $pBar, $sLabel,
      $pPrompt, $pFull, $pRRP, $pSave, $pBig,
      $cta, $search, $confirm, $cartNote;

  /* ── Helpers ────────────────────────────────────────────────── */
  function fmt(p) { return '\u00a3' + (p / 100).toFixed(2); }

  function getStdCount() {
    return _selected.filter(function (x) { return x.tier === 'standard'; }).length;
  }

  function getBundlePrice() {
    return BUNDLE_PRICES[_size][getStdCount()];
  }

  function getRRP() {
    return _selected.reduce(function (s, x) { return s + x.price; }, 0);
  }

  function getBundleVariantId() {
    return BUNDLE_VARIANTS[_size + '-' + getStdCount()];
  }

  /* ── Internal products list — populated by fetchAllProducts() ── */
  var _products = [];

  function getProducts() { return _products; }

  /* ── Split title into name + inspired-by ──────────────────── */
  function splitTitle(title) {
    var lower = (title || '').toLowerCase();
    var idx = lower.indexOf('inspired by ');
    if (idx > 2) {
      var name = title.substring(0, idx).replace(/[\s\u2010-\u2015\u2212\-]+$/, '').trim();
      var insp = title.substring(idx + 'inspired by '.length).trim();
      if (name && insp) return { name: name, inspiredBy: insp };
    }
    return { name: title || '', inspiredBy: '' };
  }

  /* ── Transform a /products.json product into our format ────── */
  function transformProduct(p, bestsellersHandles) {
    if (!p) return null;
    var handle   = p.handle || '';
    var title    = p.title || '';
    var tagsStr  = Array.isArray(p.tags) ? p.tags.join(',') : (p.tags || '');
    var tagsLow  = tagsStr.toLowerCase();

    /* Filter excluded products */
    if (tagsLow.indexOf('bundle-excluded') > -1) return null;

    var isMid = tagsLow.indexOf('mid-tier') > -1 || tagsLow.indexOf('mid tier') > -1;

    var isBS = tagsLow.indexOf('bestseller') > -1 ||
               tagsLow.indexOf('best seller') > -1 ||
               tagsLow.indexOf('best-seller') > -1 ||
               (bestsellersHandles && bestsellersHandles.indexOf(handle) > -1);

    /* Inspired by: lookup (from Liquid metafields) → title extraction */
    var inspiredBy = (window.nerosaInspirations && window.nerosaInspirations[handle]) || '';
    if (!inspiredBy) inspiredBy = splitTitle(title).inspiredBy;

    /* Product name: strip "– Inspired by X" from title */
    var displayName = splitTitle(title).name || title;

    /* Price: products.json returns as string "34.99" → convert to pence */
    var variant = p.variants && p.variants[0];
    var price   = variant ? Math.round(parseFloat(variant.price || 0) * 100) : 3499;

    /* Image */
    var imageUrl = null;
    if (p.images && p.images[0]) {
      imageUrl = p.images[0].src.replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1');
    }

    var isWomen = tagsLow.indexOf('women') > -1 || tagsLow.indexOf('woman') > -1;
    var isMen   = tagsLow.indexOf('men') > -1 && tagsLow.indexOf('women') === -1;
    var isUnisex = tagsLow.indexOf('unisex') > -1;
    return {
      variantId:  variant ? variant.id : null,
      handle:     handle,
      name:       displayName,
      tier:       isMid ? 'mid' : 'standard',
      price:      price,
      bestseller: isBS,
      inspired:   inspiredBy,
      image:      imageUrl,
      gender:     isWomen ? 'women' : (isMen ? 'men' : (isUnisex ? 'unisex' : ''))
    };
  }

  /* ── Fetch all products from the collection API ────────────── */
  function fetchAllProducts(collectionHandle, bestsellersHandles, callback) {
    var allProducts = [];
    var page        = 1;

    function fetchPage() {
      var url = '/collections/' + encodeURIComponent(collectionHandle) +
                '/products.json?limit=250&page=' + page;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var batch = data.products || [];
          var transformed = batch
            .map(function (p) { return transformProduct(p, bestsellersHandles); })
            .filter(Boolean);
          allProducts = allProducts.concat(transformed);

          if (batch.length === 250) {
            page++;
            fetchPage(); /* paginate */
          } else {
            console.log('[Nerosà Bundle] Products loaded:', allProducts.length,
              '| Bestsellers:', allProducts.filter(function(p){return p.bestseller;}).length);
            var bs = allProducts.filter(function(p){return p.bestseller;});
            if (bs.length) console.log('[Nerosà Bundle] Bestseller names:',
              bs.map(function(p){return p.name;}).join(', '));
            callback(allProducts);
          }
        })
        .catch(function (e) {
          console.error('[Nerosà Bundle] Fetch error:', e);
          callback(allProducts); /* return what we have */
        });
    }
    fetchPage();
  }

  function getFiltered() {
    var q = _query.toLowerCase().trim();
    return getProducts().filter(function (p) {
      if (_filter === 'bs' && !p.bestseller) return false;
      if (_filter === 'women'  && p.gender !== 'women')  return false;
      if (_filter === 'men'    && p.gender !== 'men')    return false;
      if (_filter === 'unisex' && p.gender !== 'unisex') return false;
      if (q && (p.name + ' ' + (p.inspired || '')).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
  }

  /* ── Slots ──────────────────────────────────────────────────── */
  function renderSlots() {
    if (!$slots) return;
    $slots.innerHTML = '';
    var full = _selected.length === _size;

    var pill = document.getElementById('nbb-ship-pill');
    var hint = document.getElementById('nbb-ship-hint');
    if (pill) pill.className = 'nbb-ship-pill' + (full ? ' is-visible' : '');
    if (hint) hint.style.display = full ? 'none' : '';

    for (var i = 0; i < _size; i++) {
      var p    = _selected[i];
      var slot = document.createElement('div');
      slot.className = 'nbb-slot' + (p ? ' is-filled' : '');
      if (p) {
        slot.innerHTML =
          '<div class="nbb-slot-body">' +
            '<div class="nbb-slot-tier">' + (p.tier === 'mid' ? 'Mid-tier' : 'Standard') + '</div>' +
            '<div class="nbb-slot-name">' + esc(p.name) + '</div>' +
            '<div class="nbb-slot-price">' + fmt(p.price) + '</div>' +
          '</div>' +
          '<button class="nbb-slot-remove" data-idx="' + i + '" type="button">\u00d7</button>';
      } else {
        slot.innerHTML = '<span class="nbb-slot-empty">Add a bottle</span>';
      }
      $slots.appendChild(slot);
    }
  }

  /* ── Progress bar ───────────────────────────────────────────── */
  function renderPBar() {
    if (!$pBar) return;
    $pBar.innerHTML = '';
    for (var i = 0; i < _size; i++) {
      var d = document.createElement('div');
      d.className = 'nbb-pbar-slot' + (i < _selected.length ? ' is-filled' : '');
      $pBar.appendChild(d);
    }
  }

  /* ── Sidebar ────────────────────────────────────────────────── */
  function renderSidebar() {
    renderPBar();
    var full = _selected.length === _size;
    var rem  = _size - _selected.length;

    if ($sLabel) {
      if (full)                  $sLabel.textContent = 'Bundle price';
      else if (_selected.length) $sLabel.textContent = fmt(getRRP()) + ' so far';
      else                       $sLabel.textContent = 'Initial price';
    }

    if (!full) {
      if ($pPrompt) {
        $pPrompt.textContent = _selected.length === 0
          ? 'Select ' + _size + ' bottles to see your bundle price'
          : 'Add ' + rem + ' more bottle' + (rem > 1 ? 's' : '') + ' to unlock your price';
        $pPrompt.style.display = '';
      }
      if ($pFull)  $pFull.style.display = 'none';
      if ($cta)    { $cta.disabled = true; $cta.textContent = 'Add to Cart'; }
    } else {
      var rrp    = getRRP();
      var bp     = getBundlePrice();
      var saving = rrp - bp;

      if ($pPrompt) $pPrompt.style.display = 'none';
      if ($pFull)   $pFull.style.display = 'block';
      if ($pRRP)    $pRRP.textContent  = fmt(rrp);
      if ($pSave)   $pSave.textContent = '\u2212' + fmt(saving);
      if ($pBig)    $pBig.textContent  = fmt(bp);
      if ($cta)     { $cta.disabled = false; $cta.textContent = 'Add to Cart \u2014 ' + fmt(bp); }
    }
  }

  /* ── Grid ───────────────────────────────────────────────────── */
  function renderGrid() {
    if (!$grid) return;
    var full     = _selected.length >= _size;
    var filtered = getFiltered();
    var pages    = Math.max(1, Math.ceil(filtered.length / PER_PAGE));

    if (_page > pages) _page = pages;
    if (_page < 1)     _page = 1;

    var paged = filtered.slice((_page - 1) * PER_PAGE, _page * PER_PAGE);
    $grid.innerHTML = '';

    if (!paged.length) {
      var msg = document.createElement('p');
      msg.className = 'nbb-no-results';
      msg.textContent = _filter === 'bs'
        ? 'No bestsellers found. Try the All Perfumes tab.'
        : 'No fragrances found.';
      $grid.appendChild(msg);
      renderPagination(0, 1);
      return;
    }

    paged.forEach(function (p) {
      var count = _selected.filter(function (s) { return s.variantId === p.variantId; }).length;
      var inB   = count > 0;
      var dim   = full && !inB;

      var card = document.createElement('div');
      card.className = 'nbb-card' + (inB ? ' is-in' : '') + (dim ? ' is-dim' : '');

      var badges = '';
      if (p.bestseller)     badges += '<span class="nbb-badge nbb-badge-bs">Bestseller</span>';
      if (p.tier === 'mid') badges += '<span class="nbb-badge nbb-badge-mid">Mid-tier</span>';

      var imgHtml = p.image
        ? '<img src="' + p.image + '" alt="' + esc(p.name) + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:#F5EFE6;"></div>';

      var inspiredHtml = p.inspired && p.inspired.trim()
        ? '<span class="nbb-card-inspo-label">Inspired by</span><span class="nbb-card-inspo-val">' + esc(p.inspired) + '</span>'
        : '<span class="nbb-card-inspo-val" style="flex:1;display:block;"></span>';

      /* Button state:
         - Bundle full + in selection  → "Added ✓" disabled
         - Bundle full + not in sel    → "Add to Bundle" disabled (dimmed card)
         - Bundle not full + in sel    → "Add Again" enabled (allows duplicate)
         - Bundle not full + not in sel → "Add to Bundle" enabled                */
      var btnText, btnDisabled, btnAdded;
      if (full) {
        btnDisabled = true;
        btnAdded    = inB;
        btnText     = inB ? 'Added \u2713' : 'Add to Bundle';
      } else if (inB) {
        btnDisabled = false;
        btnAdded    = false;
        btnText     = count > 1 ? 'Add Again (\u00d7' + count + ')' : 'Add Again';
      } else {
        btnDisabled = false;
        btnAdded    = false;
        btnText     = 'Add to Bundle';
      }

      var productUrl = p.handle ? '/products/' + p.handle : '#';
      card.innerHTML =
        '<a class="nbb-card-link" href="' + productUrl + '">' +
          '<div class="nbb-card-img">' +
            '<div class="nbb-badge-row">' + badges + '</div>' +
            imgHtml +
          '</div>' +
          '<div class="nbb-card-body">' +
            '<span class="nbb-card-title">' + esc(p.name) + '</span>' +
            inspiredHtml +
            '<span class="nbb-card-price">' + fmt(p.price) + '</span>' +
          '</div>' +
        '</a>' +
        '<div class="nbb-card-btn-wrap">' +
          '<button class="nbb-card-btn' + (btnAdded ? ' is-added' : '') + '"' +
            (btnDisabled ? ' disabled' : '') +
            ' data-variant="' + p.variantId + '" type="button">' +
            btnText +
          '</button>' +
        '</div>';

      $grid.appendChild(card);
    });

    renderPagination(filtered.length, pages);
  }

  /* ── Pagination ─────────────────────────────────────────────── */
  function renderPagination(total, pages) {
    if (!$pagination) return;
    if (pages <= 1) { $pagination.className = 'nbb-pagination'; $pagination.innerHTML = ''; return; }

    $pagination.className = 'nbb-pagination is-visible';
    $pagination.innerHTML = '';

    function makeBtn(html, onClick, isArrow, disabled) {
      var btn = document.createElement('button');
      btn.className = 'nbb-page-btn' + (isArrow ? ' nbb-page-btn--arrow' : '');
      btn.type = 'button'; btn.disabled = !!disabled; btn.innerHTML = html;
      if (!disabled) btn.addEventListener('click', onClick);
      return btn;
    }

    $pagination.appendChild(makeBtn(
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>',
      function () { _page--; go(); scrollToTray(); }, true, _page === 1
    ));

    var start = Math.max(1, _page - 2);
    var end   = Math.min(pages, start + 4);
    if (end - start < 4) start = Math.max(1, end - 4);
    for (var i = start; i <= end; i++) {
      (function (n) {
        var btn = makeBtn(n, function () { _page = n; go(); scrollToTray(); }, false, false);
        if (n === _page) btn.classList.add('is-active');
        $pagination.appendChild(btn);
      })(i);
    }

    $pagination.appendChild(makeBtn(
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg>',
      function () { _page++; go(); scrollToTray(); }, true, _page === pages
    ));
  }

  function scrollToTray() {
    var tray = document.querySelector('.nbb-tray');
    if (tray) tray.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Add / remove items ─────────────────────────────────────── */
  function addItem(variantId) {
    if (_selected.length >= _size) return;
    var p = getProducts().find(function (x) { return String(x.variantId) === String(variantId); });
    if (!p) return;
    _selected.push(p);
    go();
  }

  function removeItem(idx) {
    _selected.splice(idx, 1);
    if ($confirm) $confirm.className = 'nbb-confirm';
    go();
  }

  /* ── Add bundle to cart ─────────────────────────────────────── */
  /*
     Option 2: adds ONE bundle product variant (already correctly priced)
     with line item properties recording which scents are included.

     Properties written:
       Scent 1, Scent 2, [Scent 3]  → visible to customer in cart/order
       _bundle_id                    → hidden, links to this specific build
       _bundle_size                  → hidden, "2" or "3"
       _bundle_rrp                   → hidden, pence, for cart drawer saving display
       _bundle_saving                → hidden, pence, for cart drawer saving display

     Properties prefixed with _ are hidden from Shopify's customer-facing
     order confirmation email but are readable via JavaScript.
  */
  function addToCart() {
    if (_selected.length !== _size || $cta.disabled) return;

    var variantId = getBundleVariantId();
    var bp        = getBundlePrice();
    var rrp       = getRRP();
    var saving    = rrp - bp;
    var bundleId  = 'nb_' + Date.now();

    /* Debug: open browser console (F12) to see this */
    console.log('[Nerosà Bundle] variantId:', variantId, '| price:', fmt(bp), '| saving:', fmt(saving));

    if (!variantId) {
      alert('[Nerosà Bundle] No variant ID found. Check BUNDLE_VARIANTS table in nerosa-bundle-builder.js.');
      return;
    }

    $cta.disabled    = true;
    $cta.textContent = 'Adding\u2026';

    /* Visible properties (shown in cart and order) */
    var properties = {};
    _selected.forEach(function (p, i) {
      properties['Scent ' + (i + 1)] = p.name;
    });

    /* Hidden metadata (underscore-prefixed = hidden from customer emails) */
    properties['_bundle_id']     = bundleId;
    properties['_bundle_size']   = String(_size);
    properties['_bundle_rrp']    = String(rrp);
    properties['_bundle_saving'] = String(saving);

    fetch('/cart/add.js', {
      method:      'POST',
      credentials: 'same-origin',
      headers:     { 'Content-Type': 'application/json' },
      body:        JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
    .then(function (r) {
      console.log('[Nerosà Bundle] /cart/add.js status:', r.status);
      if (!r.ok) {
        return r.json().then(function (err) {
          var msg = err.description || err.message || ('HTTP ' + r.status);
          console.error('[Nerosà Bundle] Add failed:', msg);
          throw new Error(msg + ' (status ' + r.status + ')');
        });
      }
      return r.json();
    })
    .then(function () {
      console.log('[Nerosà Bundle] Added successfully');
      if ($confirm)  $confirm.className = 'nbb-confirm is-show';
      if ($cartNote) $cartNote.style.display = 'none';
      var trigger = document.getElementById('nerosa-cart-btn')
        || document.getElementById('nerosa-mob-cart-btn')
        || document.querySelector('[data-cart-trigger]');
      if (trigger) setTimeout(function () { trigger.click(); }, 300);
    })
    .catch(function (e) {
      console.error('[Nerosà Bundle] Error:', e.message);
      $cta.disabled    = false;
      $cta.textContent = 'Add to Cart \u2014 ' + fmt(getBundlePrice());
      alert('[Nerosà Bundle] Could not add to cart: ' + e.message + '\n\nCheck:\n1. Products set to Active (not Draft)\n2. Online Store channel enabled\n3. "Continue selling when out of stock" checked');
    });
  }

  /* ── Size / filter controls ─────────────────────────────────── */
  function setSize(n) {
    _size     = n;
    _selected = _selected.slice(0, n);
    var b2 = document.getElementById('nbb-btn-2');
    var b3 = document.getElementById('nbb-btn-3');
    if (b2) { b2.className = 'nbb-toggle-btn' + (n === 2 ? ' is-on' : ''); b2.textContent = 'Duo'; }
    if (b3) { b3.className = 'nbb-toggle-btn' + (n === 3 ? ' is-on' : ''); b3.textContent = 'Trio'; }
    if ($confirm) $confirm.className = 'nbb-confirm';
    go();
  }

  function setFilter(f) {
    _filter = f; _page = 1;
    ['all','bs','women','men','unisex'].forEach(function(k) {
      var el = document.getElementById('nbb-tab-' + k);
      if (el) el.className = 'nbb-tab' + (f === k ? ' is-on' : '');
    });
    renderGrid();
  }

  /* ── Master render ──────────────────────────────────────────── */
  function go() { renderSlots(); renderSidebar(); renderGrid(); }

  /* ── Load schema prices ─────────────────────────────────────── */
  function loadPrices() {
    var el = document.getElementById('nbb-products-json');
    if (!el) return;
    var d = el.dataset;
    function s(v, o, k) { var n = parseInt(v, 10); if (!isNaN(n)) o[k] = n; }
    s(d.p2ss,  BUNDLE_PRICES[2], 2); s(d.p2sm,  BUNDLE_PRICES[2], 1); s(d.p2mm,  BUNDLE_PRICES[2], 0);
    s(d.p3sss, BUNDLE_PRICES[3], 3); s(d.p3ssm, BUNDLE_PRICES[3], 2); s(d.p3smm, BUNDLE_PRICES[3], 1); s(d.p3mmm, BUNDLE_PRICES[3], 0);
  }

  /* ── Event binding ──────────────────────────────────────────── */
  function bindEvents() {
    var b2 = document.getElementById('nbb-btn-2');
    var b3 = document.getElementById('nbb-btn-3');
    var tA = document.getElementById('nbb-tab-all');
    var tB = document.getElementById('nbb-tab-bs');
    if (b2) b2.addEventListener('click', function () { setSize(2); });
    if (b3) b3.addEventListener('click', function () { setSize(3); });
    if (tA) tA.addEventListener('click', function () { setFilter('all'); });
    if (tB) tB.addEventListener('click', function () { setFilter('bs'); });
    var tW = document.getElementById('nbb-tab-women');
    var tM = document.getElementById('nbb-tab-men');
    var tU = document.getElementById('nbb-tab-unisex');
    if (tW) tW.addEventListener('click', function () { setFilter('women'); });
    if (tM) tM.addEventListener('click', function () { setFilter('men'); });
    if (tU) tU.addEventListener('click', function () { setFilter('unisex'); });
    if ($search) $search.addEventListener('input', function () { _query = $search.value; _page = 1; renderGrid(); });
    if ($cta) $cta.addEventListener('click', addToCart);

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.nbb-slot-remove');
      if (rm) { removeItem(parseInt(rm.dataset.idx, 10)); return; }
      var btn = e.target.closest('.nbb-card-btn:not([disabled])');
      if (btn && btn.dataset.variant) { addItem(btn.dataset.variant); }
    });
  }

  /* ── Escape HTML ────────────────────────────────────────────── */
  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Init ───────────────────────────────────────────────────── */
  function init() {
    $slots = document.getElementById('nbb-slots');
    if (!$slots) return;

    $grid       = document.getElementById('nbb-grid');
    $pagination = document.getElementById('nbb-pagination');
    $pBar       = document.getElementById('nbb-pbar');
    $sLabel     = document.getElementById('nbb-sidebar-label');
    $pPrompt    = document.getElementById('nbb-price-prompt');
    $pFull      = document.getElementById('nbb-price-full');
    $pRRP       = document.getElementById('nbb-price-rrp');
    $pSave      = document.getElementById('nbb-price-save');
    $pBig       = document.getElementById('nbb-price-big');
    $cta        = document.getElementById('nbb-cta');
    $search     = document.getElementById('nbb-search');
    $confirm    = document.getElementById('nbb-confirm');
    $cartNote   = document.getElementById('nbb-cart-note');

    loadPrices();
    bindEvents();
    fixGap();

    /* Show loading state while products are fetched */
    if ($grid) {
      $grid.innerHTML = '<p style="padding:24px;color:#9A9490;font-size:14px">Loading fragrances…</p>';
    }
    renderSidebar(); /* show initial sidebar state */

    /* Read config from data attributes — no more Liquid product loop */
    var el = document.getElementById('nbb-products-json');
    var collectionHandle   = (el && el.dataset.collection)   || 'all';
    var bestsellersStr     = (el && el.dataset.bestsellers)  || '';
    var bestsellersHandles = bestsellersStr ? bestsellersStr.split(',').filter(Boolean) : [];

    /* Fetch all products from Shopify collection API (no 50-product Liquid limit) */
    fetchAllProducts(collectionHandle, bestsellersHandles, function (products) {
      _products = products;
      go();
    });
  }

  /* ── Gap fix ──────────────────────────────────────────────────
     Shopify scopes <style> tags inside section liquid files so
     rules targeting the outer #shopify-section-* wrapper div
     never apply. This JS runs from an unscoped asset file and
     directly sets inline styles — reliable regardless of scoping.

     Header height: 38px announcement + 58px nav = 96px total.
     We pull the section up 96px and add 96+28=124px padding-top
     to nbb-page so content starts exactly 28px below the nav.
  ─────────────────────────────────────────────────────────────── */
  function fixGap() {
    /*
      nerosa-header.js (patchHeaderHeight) adds padding-top = headerHeight
      to #MainContent on all non-home pages. The sticky header also takes
      that height in document flow. So sections start at 2× header height
      from viewport top. We cancel exactly the MainContent padding by
      setting margin-top = -(headerHeight) on the section.
      The nbb-page padding-top stays at its original CSS value (28px).
      The external nerosa-bundle-gap.css handles this in CSS; this JS is
      the belt-and-braces fallback in case CSS specificity loses.
    */
    requestAnimationFrame(function () {
      var outer = document.getElementById('nerosa-header-outer');
      if (!outer) return;

      var headerH = Math.round(outer.offsetHeight);
      console.log('[Nerosà Bundle] Header height:', headerH + 'px');

      var el = document.querySelector('.nbb-page');
      if (!el) return;

      var wrapper = el.parentElement;
      while (wrapper) {
        if (wrapper.classList && wrapper.classList.contains('shopify-section')) {
          wrapper.style.marginTop = '-' + headerH + 'px';
          console.log('[Nerosà Bundle] Section margin-top set to -' + headerH + 'px');
          break;
        }
        wrapper = wrapper.parentElement;
      }
      /* Do NOT touch nbb-page padding-top — the original CSS value is correct */
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();
